// extracted by mini-css-extract-plugin
export var quillEditor = "_nr-1";
export var variable = "_nr-0";